console.log("Parent theme.js loaded.");
